import { Body, Card, Headline } from "~/ui-library";
import { TagToClassNameMap } from "~/lib/shared/html-utils";
import { BuildHtml } from "~/components/BuildHtml";

const tagToClassNameMap: TagToClassNameMap = new Map([
  ["p", "mb-m last:mb-0 body-regular"],
]);

export type CorrectionBlockCardProps = {
  bodyHTML: string;
  title?: string;
  blockId?: string;
};

export function CorrectionBlockCard({
  bodyHTML,
  title,
  blockId,
}: CorrectionBlockCardProps) {
  return (
    <Card className="p-s md:px-m">
      {title ? (
        <Headline
          blockCase
          level={6}
          className="mb-s scroll-mt-xxl"
          id={blockId}
        >
          {title}
        </Headline>
      ) : null}
      <Body className="text-gray-700" size="large">
        <BuildHtml html={bodyHTML} tagToClassNameMap={tagToClassNameMap} />
      </Body>
    </Card>
  );
}
